import { Autocomplete, TextField } from '@mui/material';
import { memo } from 'react';
import { DropDownProps } from './Dropdown.types';

export const Dropdown: React.FC<DropDownProps> = memo(
  ({ ...props }) => {

    const handleOnChange = (_:any, value: any) => {
      if (props.onChange)
        props.onChange(value.value, { action: 'select-option', option: undefined });
    };

    return (
      <>
        <Autocomplete
          disableClearable={true}
          defaultValue={props.value || ''}
          value={props.value || ''}
          onBlur={props.onBlur}
          options={props.options || []}
          onChange={handleOnChange}
          renderInput={(params) => <TextField {...params}/>}
        />
      </>
    );
  }
)
